import { TEAMS } from 'owa-config/lib/types/HostApp';
import { getQueryStringParameter, hasQueryStringParameter } from 'owa-querystring';

export function isHostedInTeams(): boolean {
    if (hasQueryStringParameter('hostApp')) {
        return getQueryStringParameter('hostApp').toLowerCase() == TEAMS;
    }
    return false;
}
